export default __webpack_public_path__ + "static/media/Liberia.407fc352.png";